var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaypassApprovalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 197,
    viewBox: "0 0 165 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.323 20.2899L125.886 8.98314C120.881 6.10458 114.719 6.10458 109.701 8.98314L18.3242 61.4327C13.2932 64.3242 10.1992 69.6664 10.1992 75.4495V158.656C10.1992 164.439 13.2932 169.768 18.3112 172.659L39.7482 184.2C44.7662 187.091 50.9542 187.091 55.9722 184.2L147.362 131.504C152.38 128.612 155.474 123.27 155.474 117.5V34.3067C155.474 28.5237 152.38 23.1685 147.349 20.2899",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.591 66.5414C81.7263 78.4836 64.8393 105.726 64.8653 127.393C64.8913 149.06 81.8303 156.944 102.695 145.002C123.56 133.06 140.447 105.817 140.421 84.1499C140.395 62.4829 123.456 54.5993 102.591 66.5414Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6094 120.431L95.7274 131.427L120.544 85.0586",
    stroke: "#0129FA",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaypassApprovalLogo);
export default __webpack_public_path__ + "static/media/daypass_approval_logo.f7cbbcb7bb37aa62b64839d8680881b2.svg";
export { ForwardRef as ReactComponent };